
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner-direct",
      function () {
        return require("private-next-pages/partner-direct.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner-direct"])
      });
    }
  